import type { SessionSummary } from "@/core/cameraApi/schemas/events";
import { isSameDay } from "date-fns";
import type { TFunction } from "i18next";
import { formatDate } from "@/core/i18n";

export function formatSessionLabel(
  session: SessionSummary,
  t: TFunction<["reports", "common"]>,
): string {
  const start = new Date(session.start_time);
  const startLabel = formatDate(start);

  if (!session.end_time) {
    return t("reports:session.running", { start: startLabel });
  }

  const end = new Date(session.end_time);
  const endLabel = formatDate(end, isSameDay(start, end) ? "time" : "dateTime");
  return `${startLabel} – ${endLabel}`;
}
